import React from 'react';
import { faqItems } from '../data/mock';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { HelpCircle, ChevronDown } from 'lucide-react';

const FAQSection = () => {
  return (
    <section id="faq" className="py-24 bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 bg-sun-blue/10 text-sun-blue rounded-full text-sm font-semibold mb-4">
            Häufige Fragen
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
            Antworten auf Ihre
            <span className="text-sun-orange"> Fragen</span>
          </h2>
          <p className="text-lg text-slate-600">
            Hier finden Sie Antworten auf die wichtigsten Fragen rund um Photovoltaik.
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqItems.map((item, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="bg-white rounded-2xl border border-slate-200 px-6 overflow-hidden data-[state=open]:shadow-lg data-[state=open]:border-sun-orange/30 transition-all duration-300"
            >
              <AccordionTrigger className="text-left hover:no-underline py-6 group">
                <div className="flex items-center gap-4 pr-4">
                  <div className="w-12 h-12 bg-sun-orange/10 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-sun-orange transition-colors">
                    <HelpCircle className="w-6 h-6 text-sun-orange group-hover:text-white transition-colors" />
                  </div>
                  <span className="font-semibold text-slate-900 text-lg group-hover:text-sun-orange transition-colors">{item.question}</span>
                </div>
              </AccordionTrigger>
              <AccordionContent className="pb-6 pl-16 pr-4 text-slate-600 leading-relaxed text-base">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* Additional Help */}
        <div className="mt-12 text-center p-8 bg-slate-100 rounded-2xl">
          <p className="text-slate-600 mb-4">
            Haben Sie weitere Fragen? Wir beraten Sie gerne persönlich.
          </p>
          <a 
            href="#kontakt" 
            className="inline-flex items-center text-sun-orange font-semibold hover:underline"
          >
            Kontakt aufnehmen
            <ChevronDown className="w-4 h-4 ml-1 rotate-[-90deg]" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
